import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import { Swipe, SwipeItem,Progress,Slider,Field,Cell,CellGroup,Search,Toast,Uploader,Loading,Tab, Tabs,Collapse, CollapseItem,Dialog,Image,ImagePreview,Circle,Popup,DatetimePicker} from 'vant';
import 'vant/lib/index.less';
import 'animate.css';
import VueTouch from "vue-touch";

Vue.use(VueCookies)
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Progress);
Vue.use(Slider);
Vue.use(Field);
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Search)
Vue.use(Toast)
Vue.use(Uploader)
Vue.use(Loading)
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Dialog);
Vue.use(Image);
Vue.use(ImagePreview);
Vue.use(Circle);
Vue.use(Popup);
Vue.use(DatetimePicker);

Vue.use(VueTouch, {name: "v-touch"});

Vue.config.productionTip = false
const kmsVm=new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
export default kmsVm
